import { BRAND, whatsappLink } from "@/lib/brand";
import { EnquiryForm } from "@/components/EnquiryForm";
import { BrandSignature } from "@/components/BrandSignature";
import { GoogleMapSection } from "@/components/GoogleMapSection";
import { Phone, Mail, MapPin, MessageCircle, ArrowUpRight } from "lucide-react";

export default function Contact() {
  return (
    <div data-testid="page-contact" className="overflow-x-hidden">
      <section className="section-pad pb-12">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12">
          <div className="overline">Reach Us</div>
          <h1 className="h-display text-[44px] sm:text-[56px] md:text-[72px] lg:text-[88px] font-light mt-6 tracking-[-0.025em] leading-[1.02]">
            One click. <span className="italic text-gold">One warm hello</span>.
          </h1>
          <div className="mt-8">
            <BrandSignature size="md" tone="ink" data-testid="contact-brand-signature" />
          </div>
          <p className="mt-8 text-ink-soft max-w-lg text-[15px] leading-relaxed">Speak to a human. No forms if you don't want them — call, WhatsApp, or write.</p>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-6 md:px-12 pb-16 grid grid-cols-1 md:grid-cols-12 gap-6">
        {[
          { icon: Phone, label: "Call", value: BRAND.phone, href: `tel:${BRAND.phone.replace(/\s/g, "")}`, meta: "Every day · 6 AM – 10 PM IST", testid: "contact-phone-card" },
          { icon: MessageCircle, label: "WhatsApp", value: BRAND.phone, href: whatsappLink(), meta: "Instant replies from our team", testid: "contact-whatsapp-card", ext: true },
          { icon: Mail, label: "Email", value: BRAND.email, href: `mailto:${BRAND.email}`, meta: `Or ${BRAND.supportEmail}`, testid: "contact-email-card" },
        ].map(c => (
          <a
            key={c.label}
            href={c.href}
            target={c.ext ? "_blank" : undefined}
            rel={c.ext ? "noreferrer" : undefined}
            className="md:col-span-4 group border border-kc hover:border-gold p-8 md:p-10 transition-colors bg-surface"
            data-testid={c.testid}
          >
            <div className="flex items-start justify-between">
              <c.icon size={22} className="text-gold" />
              <ArrowUpRight size={18} className="text-ink-mute group-hover:text-gold transition-colors" />
            </div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-ink-mute mt-10">{c.label}</div>
            <div className="font-serif-display text-3xl mt-3 leading-tight">{c.value}</div>
            <div className="text-[12px] uppercase tracking-[0.22em] text-ink-soft mt-4">{c.meta}</div>
          </a>
        ))}
      </section>

      <section className="max-w-[1500px] mx-auto px-6 md:px-12 pb-16">
        <div className="border border-kc p-8 md:p-10 bg-surface">
          <MapPin size={22} className="text-gold" />
          <div className="overline no-line mt-8">The House</div>
          <div className="font-serif-display text-2xl mt-3 leading-tight">{BRAND.business}</div>
          <p className="text-ink-soft text-[14px] mt-5 leading-relaxed max-w-2xl">{BRAND.address}</p>
        </div>
      </section>

      {/* Premium Google Map — Directions, Open in Maps, Zoom, Satellite */}
      <GoogleMapSection />

      <section className="section-pad pt-8">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12">
          <EnquiryForm type="contact" dark />
        </div>
      </section>
    </div>
  );
}
